import { createSvgIcon } from "@mui/material";

export const RemoveBackgroundIcon = createSvgIcon(
  <svg viewBox="0 0 47 47" fill="currentColor">
    <path
      d="M9.18304 0H11.6875C12.5223 0 13.3571 0.834821 13.3571 1.66964C13.3571 2.60882 12.5223 3.33929 11.6875 3.33929H9.18304C5.9481 3.33929 3.33929 6.05246 3.33929 9.18304V11.6875C3.33929 12.6267 2.50446 13.3571 1.66964 13.3571C0.730469 13.3571 0 12.6267 0 11.6875V9.18304C0 4.17411 4.06976 0 9.18304 0Z"
      fill="currentColor"
    />
    <path
      d="M1.66964 16.6964C2.50446 16.6964 3.33929 17.5313 3.33929 18.3661V28.3839C3.33929 29.3231 2.50446 30.0536 1.66964 30.0536C0.730469 30.0536 0 29.3231 0 28.3839V18.3661C0 17.5313 0.730469 16.6964 1.66964 16.6964Z"
      fill="currentColor"
    />
    <path
      d="M46.75 18.3661C46.75 17.5313 45.9152 16.6964 45.0804 16.6964C44.1412 16.6964 43.4107 17.5313 43.4107 18.3661V28.3839C43.4107 29.3231 44.1412 30.0536 45.0804 30.0536C45.9152 30.0536 46.75 29.3231 46.75 28.3839V18.3661Z"
      fill="currentColor"
    />
    <path
      d="M45.0804 13.3571C44.1412 13.3571 43.4107 12.6267 43.4107 11.6875V9.18304C43.4107 6.05246 40.6975 3.33929 37.567 3.33929H35.0625C34.1233 3.33929 33.3929 2.60882 33.3929 1.66964C33.3929 0.834821 34.1233 0 35.0625 0H37.567C42.5759 0 46.75 4.17411 46.75 9.18304V11.6875C46.75 12.6267 45.9152 13.3571 45.0804 13.3571Z"
      fill="currentColor"
    />
    <path
      d="M46.75 37.567V35.0625C46.75 34.2277 45.9152 33.3929 45.0804 33.3929C44.1412 33.3929 43.4107 34.2277 43.4107 35.0625V37.567C43.4107 40.8019 40.6975 43.4107 37.567 43.4107H35.0625C34.1233 43.4107 33.3929 44.2455 33.3929 45.0804C33.3929 46.0195 34.1233 46.75 35.0625 46.75H37.567C42.5759 46.75 46.75 42.6802 46.75 37.567Z"
      fill="currentColor"
    />
    <path
      d="M3.33929 35.0625V37.567C3.33929 40.8019 5.9481 43.4107 9.18304 43.4107H11.6875C12.5223 43.4107 13.3571 44.2455 13.3571 45.0804C13.3571 46.0195 12.5223 46.75 11.6875 46.75H9.18304C4.06976 46.75 0 42.6802 0 37.567V35.0625C0 34.2277 0.730469 33.3929 1.66964 33.3929C2.50446 33.3929 3.33929 34.2277 3.33929 35.0625Z"
      fill="currentColor"
    />
    <path
      d="M16.6964 45.0804C16.6964 46.0195 17.4269 46.75 18.3661 46.75H28.3839C29.2188 46.75 30.0536 46.0195 30.0536 45.0804C30.0536 44.2455 29.2188 43.4107 28.3839 43.4107H18.3661C17.4269 43.4107 16.6964 44.2455 16.6964 45.0804Z"
      fill="currentColor"
    />
    <path
      d="M16.6964 1.66964C16.6964 0.834821 17.4269 0 18.3661 0H28.3839C29.2188 0 30.0536 0.834821 30.0536 1.66964C30.0536 2.60882 29.2188 3.33929 28.3839 3.33929H18.3661C17.4269 3.33929 16.6964 2.60882 16.6964 1.66964Z"
      fill="currentColor"
    />
    <path
      d="M13.5383 18.177C15.0477 18.177 16.4009 17.3963 17.1815 16.0952C17.9102 14.8461 17.9102 13.2327 17.1815 11.9315C16.4009 10.6824 15.0477 9.84967 13.5383 9.84967C12.081 9.84967 10.7278 10.6824 9.94716 11.9315C9.21852 13.2327 9.21852 14.8461 9.94716 16.0952C10.7278 17.3963 12.081 18.177 13.5383 18.177Z"
      fill="currentColor"
    />
    <path
      d="M37.1672 39.7961C38.7285 39.7961 40.0297 38.4949 40.0297 36.9335C40.0297 36.361 39.8736 35.8406 39.6133 35.3722L28.3194 17.3643C28.0071 16.8438 27.3825 16.4795 26.7059 16.4795C26.0814 16.4795 25.4568 16.8438 25.1446 17.3643L18.5868 27.8255L16.0886 23.7139C15.8283 23.4016 15.464 23.1414 15.0477 23.1414C14.6833 23.1414 14.267 23.4016 14.0588 23.7139L7.18873 35.0078C6.9285 35.4762 6.72031 36.0488 6.72031 36.6213C6.72031 38.3908 8.1776 39.7961 9.94716 39.7961H37.1672Z"
      fill="currentColor"
    />
  </svg>,
  "RemoveBackgroundIcon",
);
